import { useState, useEffect } from "react";

const COOKIE_CONSENT_KEY = "cookieConsent";

export const useCookieConsent = () => {
  const [hasConsented, setHasConsented] = useState<boolean | null>(null);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    setHasConsented(consent === "accepted");
  }, []);

  const acceptCookies = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "accepted");
    setHasConsented(true);
  };

  return {
    hasConsented,
    acceptCookies,
    isLoading: hasConsented === null,
  };
};
